import { Moon, Sun, SunMoon } from "lucide-react";

import { Button } from "#/components/ui/button";

import { useTheme } from "./ThemeProvider";

type ThemeMode = "light" | "dark" | "system";

export default function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  function toggleMode() {
    const nextMode: ThemeMode = theme === "light" ? "dark" : theme === "dark" ? "system" : "light";
    setTheme(nextMode);
  }

  const label = "Click to switch between light, dark, and system mode.";

  return (
    <Button variant="outline" onClick={toggleMode} aria-label={label} title={label}>
      {theme === "light" ? <Moon /> : theme === "dark" ? <SunMoon /> : <Sun />}
    </Button>
  );
}
